export default __webpack_public_path__ + "static/media/play-run@2x.40edb3d3.png";